import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const animateTimeline = () => {
  const section = document.querySelector('[data-block="timeline"]');

  if (!section) return;

  const timelineItems = section.querySelectorAll('[data-element^="timeline-"]');
  if (!timelineItems.length) return;

  ScrollTrigger.matchMedia({
    "(min-width: 1200px)": function () {
      timelineItems.forEach((item, index) => {
        const direction = index % 2 === 0 ? "-100%" : "100%";

        const entry = item.closest(".timeline__item");
        if (!entry) return;

        const line = entry.querySelector('[data-element="line"]');
        const icon = entry.querySelector('[data-element="icon"]');
        if (!icon || !line) return;

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            start: "top 65%",
          },
        });

        tl.fromTo(item, { x: direction }, { x: 0, duration: 1, ease: "none" })
          .fromTo(
            line,
            { height: "0%" },
            { height: "100%", duration: 1, ease: "none", delay: 0.5 },
            "<"
          )
          .fromTo(
            icon,
            {
              display: "none",
            },
            {
              display: "flex",
              duration: 1,
              ease: "none",
              delay: 0.2,
            },
            "<"
          );
      });
    },
  });
};

export { animateTimeline };
